import request from '@/request/http'
///获取详情
export function chatList(data) {
  return request({
      url: `ai/vllm/chatList` ,
      method: 'post',
      data: data
  })
}

///获取聊天记录
export function chatRecords(data) {
  return request({
      url: `ai/vllm/chatRecords` ,
      method: 'post',
      data: data
  })
}


///删除会话记录
export function delChatRecords(data) {
  return request({
      url: `ai/vllm/delChatRecords` ,
      method: 'post',
      data: data
  })
}

///重命名
export function renameConversation(data) {
  return request({
      url: `ai/vllm/renameConversation` ,
      method: 'post',
      data: data
  })
}


export function findQuestionAnswerConfigList() {
  return request({
      url: `ai/qaConfig/findQuestionAnswerConfigList` ,
      method: 'get',
  })
}

//文生图 
export function textGenerateImage(id) {
  return request({
      url: `ai/img/textGenerateImage?prompt=${id}` ,
      method: 'get',
      //data: data
  })
}

//图生图
export function imageGenerateImage(id,prompt) {
  return request({
      url: `ai/img/imageGenerateImage?imgUrl=${id}&prompt=${prompt}` ,
      method: 'get',
      //data: data
  })
}